import React, { useContext } from 'react'

// Components
import { Panel, Button, Text } from '../../../../../components'

// Context
import { AppContext } from '../../../../../contexts'

// Constants
import { TABS } from '../../../../../constants/display'

import styles from './ToDo.module.scss'

const ToDo = () => {
  const { activeTab, setActiveTab } = useContext(AppContext)

  return (
    <Panel className={styles.root}>
      <div className={styles.body}>
        <Text
          size='s'
          letterSpacing='large'
          color='white'
          weight='semibold'
          transform='uppercase'
        >
          to do: edit your profile
        </Text>
        <Text>Improve your report by changing our starter values</Text>
      </div>
      <Button
        className={styles.edit}
        onClick={e => setActiveTab(TABS.SETTINGS)}
        regular
        tabIndex='0'
      >
        Edit
      </Button>
    </Panel>
  )
}

export default ToDo
